import * as Msal from '@azure/msal-browser'
import config from './config'
import store from '../../store/store'

export default class AuthService {
  constructor (redirectUrl) {
    this.redirecturl = redirectUrl
    this.applicationConfig = {
      clientId: config.clientid,
      authority: config.authority,
      redirectUri: config.redirecturl
    }
    this.app = new Msal.PublicClientApplication({auth: this.applicationConfig})

    this.app.initialize().then(() => {
      this.app.handleRedirectPromise().then(this.handleResponse.bind(this)).catch(err => {
        console.log(err)
      })
    })
  }

  async handleResponse (resp) {
    if (resp !== null) {
      const {accessToken, account: {username}} = resp
      const payload = {authData: {username, accessToken}, redirectpath: this.app.redirectUrl}
      store.dispatch('ssoLogin', payload)
    }
  }
  async signIn () {
    try {
      const loginRequest = {
        scopes: ['openid', 'profile', 'User.Read']
      }
      await this.app.loginRedirect(loginRequest)
    } catch (err) {
      console.error('error in signIN ', err.message)
      throw new Error('Sing in Error')
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/msal/index.js